module.exports = __webpack_public_path__ + "img/Web development _Isometric.179dd19b.png";